import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import {
  IAttempt,
  IAttemptListItemResponseForWorkOrder,
} from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const getAttemptUUID = createUUID();
const updateAttemptUUID = createUUID();

export const useWorkOrderAttemptDrawerViewModel = ({
  listAttempt,
  updateAttempt,
}: {
  listAttempt: IAttempt;
  updateAttempt?: (attempt: IAttempt) => void;
}) => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const [attempt, setAttempt] = useState<IAttempt | null>(null);

  const getAttempt = () => {
    stateManager.abort(getAttemptUUID);
    stateManager.run(async () => {
      const { status, data } = await taskService.attempts.get(listAttempt.id);

      if (status === HTTP_STATUSES.OK) {
        setAttempt(data);
        updateAttempt?.({ ...listAttempt, ...data });
      }
    }, getAttemptUUID);
  };

  const updateAttemptDates = (
    attempt: IAttemptListItemResponseForWorkOrder
  ) => {
    stateManager.abort(updateAttemptUUID);
    stateManager.run(async () => {
      const { status, data } = await taskService.attempts.updateDates({
        id: attempt.id,
        data: {
          startDate: attempt.startDate,
          endDate: attempt.endDate,
        },
        modifiedOn: attempt.modifiedOn,
        toastMessageConfig: {
          success: {
            text: "Work Order Dates Updated",
          },
        },
      });
      if (status === HTTP_STATUSES.OK) {
        updateAttempt?.(data);
        setAttempt(data);
      }
    }, updateAttemptUUID);
  };

  return {
    isLoading,
    attempt,
    stateManager,
    setAttempt,
    getAttempt,
    updateAttemptDates,
  };
};
